import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { BRAND } from "../../data/content";
import { useInstagramFeed } from "../../hooks/useInstagramFeed";

const IgTile = ({ post, index }) => (
  <Reveal delay={index * 0.05} className="group relative aspect-square overflow-hidden">
    {post.mediaUrl ? (
      <a
        href={post.permalink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`ig-tile-${index}`}
        className="block h-full w-full"
      >
        <img
          src={post.mediaUrl}
          alt={post.caption || "Blacklion Construction Instagram post"}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-black/0 transition-colors duration-300 group-hover:bg-black/60">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#e9d9ab] opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            View Post &rarr;
          </span>
        </div>
      </a>
    ) : (
      <div
        data-testid={`ig-tile-${index}`}
        className="flex h-full w-full items-center justify-center bg-[repeating-linear-gradient(135deg,#221f1a,#221f1a_11px,#1a1815_11px,#1a1815_22px)]"
      >
        <span className="px-2 text-center font-mono text-[10px] uppercase tracking-wider text-[#c9a24d]/40">
          IG Post {index + 1}
        </span>
      </div>
    )}
  </Reveal>
);

export const InstagramFeed = () => {
  const { data: posts, isLoading } = useInstagramFeed();
  const tiles = isLoading || !posts
    ? Array.from({ length: 8 }, (_, i) => ({ id: `skeleton-${i}`, mediaUrl: null }))
    : posts;

  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="border-t border-[#c9a24d]/25 bg-[#0a0a0a] py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            center
            overline="Stay Connected"
            title={`Follow @${BRAND.instagramHandle}`}
            sub="Fresh from the jobsite. Recent builds, progress shots and finished work, straight from Instagram."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-1.5 sm:grid-cols-4">
          {tiles.map((post, i) => (
            <IgTile key={post.id} post={post} index={i} />
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href={`https://www.instagram.com/${BRAND.instagramHandle}/`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-cta"
            className="inline-flex items-center gap-2 border border-[#c9a24d]/55 px-7 py-3 text-xs font-bold uppercase tracking-[0.15em] text-[#e9d9ab] transition-all hover:border-[#c9a24d] hover:bg-[#c9a24d] hover:text-black"
          >
            Follow on Instagram
            <ArrowRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
};
